export default {
  title: "Invoice to",

  input: {
    title: "Whom to invoice",

    module: "Type",
    target: "Target",
    address: "Address",
    email: "Email address",
  },

  view: {
    entityName: {
      label: "Name",
      noValue: "No entity selected",
    },
    entityAddress: {
      label: "Address",
      noValue: "No address selected",
    },
    entityEmail: {
      label: "Email address",
      noValue: "No email address selected",
    },
  },
}
